import type { FaireProductEntity } from "../../entity_types/product";

export const p_vqxnxmr8ng: FaireProductEntity = {
  token: "p_vqxnxmr8ng",
  type: "product",
  name: "Ionic Trace Minerals (Korean Bamboo Salt) | Natural Electrolyte Drops",
  brandToken: "b_etjm2nc4kj",
  brandName: "aquaViv",
  imageUrl:
    "https://cdn.faire.com/fastly/f05fcbe9a90da95ca8bef1926fb718a630a7ed70bc4fd27e9a03acbb61d44494.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c289b8ad53412a9759066431f84e563b46e38e4af5542d797e61c7fb85f7313d.png",
    "https://cdn.faire.com/fastly/1836073b82116e1529661c2cb3fb035652a5ef40204577332a862732f3b81db7.jpeg",
  ],
  priceDollars: 17.31,
  description:
    "Ionic Trace Minerals - Powered by Bamboo Salt\n\nHydration begins with minerals.\nOur Ionic Trace Minerals are crafted from bamboo salt—a centuries-old Korean preparation that transforms pure sea salt into a potent source of bioavailable electrolytes and trace elements.\n\nThrough a precise process of sealing sea salt inside bamboo stalks and firing it multiple times at over 800 °C in earthen kilns, bamboo salt becomes highly alkaline and rich in essential minerals such as magnesium, potassium, calcium, iron, and zinc. This thermal transformation neutralizes impurities and restructures the minerals into an ionic form your body can absorb with ease.\n\nEach drop helps restore the natural electrical balance of your cells—supporting hydration, muscle recovery, nerve function, and overall energy metabolism.\nThe result is a clean, ocean-derived mineral complex refined through bamboo, earth, and fire—a modern delivery of an ancient remedy.\n\n• 100% natural and plant-based\n• Lab-tested for purity and bioavailability\n• Sourced from authentic bamboo-salt artisans\n• Designed for daily hydration and mineral renewal\n\nReawaken your body’s mineral intelligence—starting with every sip.\n",
  tags: [],
  msrpDollars: 34.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:38.912Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
